import { Variable, VariableSummary } from '@mtna/pojo-consumer-ui';

import { RdsNumericFilter } from '../../../numeric-filter/numeric-filter.model';
import { BaseFilter } from './base-filter.model';
import { RdsNullFilter } from './null-filter.model';

export class FilterByNumber<V extends Variable | VariableSummary> extends BaseFilter<V> {
  constructor(variable: V, public numericFilters: Array<RdsNumericFilter>, nullFilter?: RdsNullFilter) {
    super(variable, nullFilter);
  }
}

export function instanceOfFilterByNumber(obj: any): obj is FilterByNumber<Variable | VariableSummary> {
  return !!obj && 'variable' in obj && 'numericFilters' in obj;
}
